import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  asPaginatedContent,
  getConfigObject,
  useBaseContent,
} from "../../utils/utils";
import {
  ProviderSignature,
  ProviderSignatureControllerApi,
} from "../../services";
import { Identified } from "../../types/sdk-types";

interface Props {
  providerUuid: string;
  xTENANTID?: string;
}

/**
 *
 * @author [Atish Bagate]
 */
export const useGetSignatureByProviderID = ({
  providerUuid,
  xTENANTID,
}: Props): useBaseContent<Identified<ProviderSignature>> => {
  return useQuery({
    queryKey: ["provider-signature-by-providerID", providerUuid, xTENANTID],

    refetchOnWindowFocus: false,
    enabled: !!providerUuid && !!xTENANTID,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new ProviderSignatureControllerApi(getConfigObject())
        .getProviderSignatureByProviderUuid(providerUuid, xTENANTID)
        .then((res) =>
          asPaginatedContent<Identified<ProviderSignature>>(res?.data)
        ),
  });
};
